import React, { PureComponent } from 'react';
import classnames from 'classnames';

let guides = [
    {
        label: 'Excel',
        extension: 'spreadsheet',
        type: null,
        url: 'csv_sample_sheet'
    },
    {
        label: 'Word',
        extension: 'document',
        type: null,
        url: 'csv_sample_document'
    },
    {
        label: 'Text',
        extension: '.csv',
        type: ',',
        url: 'csv_sample_comma'
    },
    {
        label: 'Text',
        extension: '.csv',
        type: 'Tab ⇥',
        url: 'csv_sample_tab'
    },
    {
        label: 'Text',
        extension: '.csv',
        type: '|',
        url: 'csv_sample_bar'
    }
];

export default class extends PureComponent {
    constructor(...props) {
        super(...props);
        this.state = {
            currentHint: 0
        };
        this.setHint = this.setHint.bind(this);
    }
    setHint(currentHint) {
        this.setState({ currentHint });
    }
    render() {
        const { currentHint } = this.state;
        const { label, url } = guides[currentHint];

        const navs = guides.map((guide, index) => {
            let { extension, label, type } = guide;
            let classes = classnames({ selected: currentHint === index });

            return <div key={index } onClick={ () => this.setHint(index) } className={classes}>
                { label }
                { extension ? <span>{ extension }</span> : null }
                { type ? <code>{ type }</code> : null }
            </div>;
        });

        return (<div className="guide">
            <div className="nav">{ navs }</div>
            <div className="body">
                <img src={ `${ process.env.PUBLIC_URL }/images/${ url }.png` } alt={ label } />
            </div>
        </div>);
    }
}




// WEBPACK FOOTER //
// ./src/components/importer/guide.js